import { render, staticRenderFns } from "./TeacherEvals.vue?vue&type=template&id=1ac60cac&scoped=true&"
import script from "./TeacherEvals.vue?vue&type=script&lang=js&"
export * from "./TeacherEvals.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEvals.vue?vue&type=style&index=0&id=1ac60cac&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac60cac",
  null
  
)

export default component.exports